module.exports = __webpack_public_path__ + "static/pei-be77df4b0ce70526673427ec1f12ba6c.png";